// Contact page topic switcher. Shows one category's HubSpot form at a time by
// toggling the [data-topic-fields] wrappers (and any [data-topic-panel] intro)
// from the radio pills / mobile <select>. The form is HubSpot-embedded now (no
// native .contact-form), so this only drives visibility.
(() => {
  const root = document.querySelector('[data-contact-topic]');
  if (!root) return;

  const extras = document.querySelectorAll('[data-topic-fields]');
  if (!extras.length) return;

  const panels = document.querySelectorAll('[data-topic-panel]');
  const radios = root.querySelectorAll('input[type="radio"][name="topic"]');
  const select = root.querySelector('.contact-topic__select');

  // Live region so swapping the form is announced to assistive tech.
  const status = document.createElement('span');
  status.className = 'sr-only';
  status.setAttribute('aria-live', 'polite');
  root.appendChild(status);

  const labelFor = (key) => {
    const r = Array.from(radios).find((x) => x.value === key);
    const lbl = r && (r.closest('label') || document.querySelector('label[for="' + r.id + '"]'));
    return (lbl ? lbl.textContent : key).trim();
  };

  const setTopic = (key, announce) => {
    if (!key) return;
    radios.forEach((r) => { r.checked = (r.value === key); });
    if (select) select.value = key;

    panels.forEach((p) => { p.hidden = (p.dataset.topicPanel !== key); });
    extras.forEach((e) => { e.hidden = (e.dataset.topicFields !== key); });

    // Update URL hash for shareable links (e.g. /contact#press).
    if (location.hash !== '#' + key) history.replaceState(null, '', '#' + key);

    if (announce) status.textContent = 'Showing the ' + labelFor(key) + ' form.';
  };

  // Init from URL hash (e.g., /contact#support). Ignore unknown hashes so a
  // bad/stale anchor can't leave every panel hidden — fall back to support,
  // then the first available topic.
  const keys = Array.from(radios, (r) => r.value);
  const fromHash = (location.hash || '').replace(/^#/, '');
  const initial = keys.indexOf(fromHash) !== -1 ? fromHash
    : (keys.indexOf('support') !== -1 ? 'support' : keys[0]);
  setTopic(initial, false);

  radios.forEach((r) => r.addEventListener('change', (e) => setTopic(e.target.value, true)));
  if (select) select.addEventListener('change', (e) => setTopic(e.target.value, true));
})();
